import {
  GET_BOOKINGS,
  GET_BOOKINGS_ERROR,
} from "../constants/TimeslotsConstants";

const INITIAL_STATE = {
  timeslots: null,
  loading: true,
};
const timeslotsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_BOOKINGS:
      return {
        ...state,
        timeslots: action.payload,
        loading: false,
      };
    case GET_BOOKINGS_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default timeslotsReducer;
